<template>
  <div
    class="cooperation-detail-container"
    id="cooperation-detail-container-id"
  >
    <transition name="fade">
      <cooperation-detail-head-cp v-show="sticky"></cooperation-detail-head-cp>
    </transition>
    <contract-agreement-cp
      v-if="data.length"
      :mainContract="mainContract"
      :mainContractGuid="mainContractGuid"
      @handMore="handMore"
      :data="repairContracts"
      :total="data.length"
    ></contract-agreement-cp>

    <div class="tabs-box" id="cooperation-detail-container-tabs-box-id">
      <van-tabs
        v-model="active"
        color="#36C490"
        title-inactive-color="#000"
        title-active-color="#36C490"
      >
        <van-tab title="产值申报" v-if="reportAuth">
          <report-detail></report-detail>
        </van-tab>
        <van-tab title="付款申请" v-if="payAuth">
          <pay-detail></pay-detail>
        </van-tab>
        <van-tab title="签证变更" v-if="visaAuth">
          <visa-detail></visa-detail>
        </van-tab>
        <van-tab title="合同结算" v-if="accountsAuth">
          <accounts-detail></accounts-detail>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import cooperationDetailHeadCp from './cooperation-packge/components/cooperation-detail-head-cp';
import visaDetail from './cooperation-packge/cooperation-visa-detail';
import accountsDetail from './cooperation-packge/cooperation-accounts-detail';
import payDetail from './cooperation-packge/cooperation-pay-detail';
import reportDetail from './cooperation-packge/cooperation-report-detail';
import contractAgreementCp from './cooperation-packge/components/cooperation-contract-agreement-cp';
import { getUrlParams } from 'common/js/mUtils';
import { mapState } from 'vuex';
import { Tab, Tabs } from 'vant';
export default {
  components: {
    cooperationDetailHeadCp,
    visaDetail,
    accountsDetail,
    payDetail,
    reportDetail,
    contractAgreementCp,
    'van-tabs': Tabs,
    'van-tab': Tab
  },
  name: 'cooperation-detail',
  data() {
    return {
      sticky: true,
      index: 0,
      data: [],
      repairContracts: [],
      active: '0',
      watertext: '',
      watermobile: '',
      mainContract: '',
      mainContractGuid: ''
    };
  },
  computed: mapState({
    reportAuth: state => state.reportAuth,
    payAuth: state => state.payAuth,
    visaAuth: state => state.visaAuth,
    accountsAuth: state => state.accountsAuth
  }),
  created() {
    let {
      contractguid,
      index,
      mainContractGuid,
      mainContract
    } = this.$route.query;
    if (!contractguid) {
      contractguid = getUrlParams().id;
      index = getUrlParams().index;
    }
    this.mainContract = mainContract;
    this.mainContractGuid = mainContractGuid;
    this.active = index;
    let { employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    this._getContractRepairInfos({ contractguid });
    this.index = index;
  },
  methods: {
    handleScroll() {},
    handMore() {
      let { contractguid, index } = this.$route.query;
      this.$router.push({
        name: 'contractAgreement',
        query: {
          contractguid,
          index
        }
      });
    },
    _getContractRepairInfos(params) {
      this.$api.getContractRepairInfos(params).then(res => {
        let { body } = res;
        if (res.status) {
          this.data = body;
          let repairContracts = JSON.parse(JSON.stringify(body));
          this.repairContracts =
            repairContracts.length > 3
              ? repairContracts.splice(0, 3)
              : repairContracts;
        }
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }
};
</script>

<style scoped lang="scss">
.cooperation-detail-container {
  font-family: PingFang SC;
  -webkit-overflow-scrolling: touch; //有回弹效果;
  overflow-y: auto;
  height: 100%;
  position: relative;
  z-index: 9;
  .tabs-box {
    margin-top: 20px;
  }
  /deep/ .van-tabs__nav {
    position: relative;
    display: flex;
    background-color: transparent;
    user-select: none;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: 1s;
    opacity: 1;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
